import React from "react";

import { Box } from "@material-ui/core";

export const HashIcon = ({ ml = 0, mt = 0 }) => {
  return (
    <Box
      component="span"
      fontSize="20px"
      ml={ml}
      mt={mt}
      fontWeight="bold"
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
    >
      #
    </Box>
  );
};
